import React from "react";
import SectionHeader from "../section/SectionHeader";
import kitchenBg from "../../../assets/images/banner-back-1.jpg";

const Services = () => {
  return (
    <div className="container-fluid">
      <SectionHeader title="SERVICES" backgroundImage={kitchenBg} />
      <div className="row">
        <div className="col-md-6 mb-4 d-flex" data-sal='slide-right' data-sal-duration="2000" data-sal-delay="300">
          <div className="service_box_1 d-flex flex-column">
            <div className="image-container">
              <img
                className="service_pic_1 img-fluid"
                src="assets\Images\Kitchen\kitc-12.jpg"
                alt=""
              />
            </div>
            <div className="text-container flex-grow-1 p-4">
              <h2 className="text-center"style={{fontSize:'40px'}}>
                <a href="/" style={{ color: "black" }}>
                  KITCHEN <span>RENOVATION</span>
                </a>
              </h2>
              <p>
                Revamp your kitchen with stylish, contemporary designs and
                premium finishes. Whether you're looking for a full renovation
                or just a few modern upgrades, our team is here to help you
                create the perfect kitchen. From sleek cabinetry and innovative
                layouts to top-of-the-line appliances and finishes, we ensure
                your kitchen not only looks amazing but also enhances your
                cooking experience and functionality.
              </p>
            </div>
            <div className="t-c">
              <a href="/kitchen-renovations">
                <button className="btn round_teo quote-btn">Learn More</button>
              </a>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4 d-flex" data-sal='slide-left' data-sal-duration="2000" data-sal-delay="300">
          <div className="service_box_1 d-flex flex-column">
            <div className="image-container">
              <img
                className="service_pic_1 img-fluid"
                src="assets\Images\Bathroom\bath12.jpg"
                alt=""
              />
            </div>
            <div className="text-container p-4 flex-grow-1">
              <h2 className="text-center" style={{fontSize:'40px'}}>
                <a href="/" style={{ color: "black" }}>
                  BATHROOM <span>RENOVATION</span>
                </a>
              </h2>
              <p>
                Transform your bathroom into a serene, spa-inspired retreat. Our
                expert team specializes in creating luxurious bathroom spaces
                that blend modern design with exceptional functionality. Whether
                it's installing a sleek, walk-in shower, designing custom
                vanities, or adding high-end finishes, we focus on every detail
                to deliver a space where relaxation and style meet. From the
                latest fixtures to thoughtful layouts, we ensure your bathroom
                not only meets your needs but exceeds your expectations.
              </p>
            </div>
            <div className="t-c">
              <a href="/bathroom-renovation">
                <button className="btn round_teo quote-btn">Learn More</button>
              </a>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4 d-flex" data-sal='slide-right' data-sal-duration="2000" data-sal-delay="300">
          <div className="service_box_1 d-flex flex-column">
            <div className="image-container">
              <img
                className="service_pic_1 img-fluid"
                src="assets\Images\Home\home12.jpg"
                alt=""
              />
            </div>
            <div className="text-container p-4 flex-grow-1">
              <h2 className="text-center" style={{fontSize:'40px'}}>
                <a href="/" style={{ color: "black" }}>
                  HOME <span>RENOVATIONS</span>
                </a>
              </h2>
              <p>
                Expand your living space with our expert home extension
                services. At Velar Heights Renovation, we specialize in
                designing and building seamless home additions that integrate
                flawlessly with your existing structure. Whether you're looking
                for a cozy room for extra comfort, a home office for improved
                productivity, or a larger living area for your growing family,
                we tailor each project to suit your specific needs. Our
                experienced team works closely with you every step of the way,
                ensuring that the new space enhances your home's functionality
                and aesthetic appeal. With attention to detail, quality
                craftsmanship, and a focus on durability, we turn your vision
                into a reality, adding both value and comfort to your home.
              </p>
            </div>
            <div className="t-c">
              <a href="/home-renovation">
                <button className="btn round_teo quote-btn">Learn More</button>
              </a>
            </div>
          </div>
        </div>

        <div className="col-md-6 mb-4 d-flex" data-sal='slide-left' data-sal-duration="2000" data-sal-delay="300"> 
          <div className="service_box_1 d-flex flex-column">
            <div className="image-container">
              <img
                className="service_pic_1 img-fluid"
                src="assets\Images\Basement\bm8.jpg"
                alt=""
              />
            </div>
            <div className="text-container p-4 flex-grow-1">
              <h2 className="text-center" style={{fontSize:'40px'}}>
                <a href="/" style={{ color: "black" }}>
                  BASEMENT <span>RENOVATIONS</span>
                </a>
              </h2>
              <p>
                Transform your basement into a versatile, stylish living space.
                Whether you envision a cozy home theater, a fully-equipped gym,
                or an additional bedroom, our expert team can bring your ideas
                to life. We specialize in maximizing the potential of your
                basement, creating a space that not only enhances your home but
                also adds value and comfort. Whatever your needs, we’ll help you
                design and build the perfect space tailored to your lifestyle.
              </p>
            </div>
            <div className="t-c">
              <a href="/basement-renovation">
                <button className="btn round_teo quote-btn">Learn More</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
